<template>
  <section id="kelas-iklim">
    <Header :scrolled="true"/>
    <div class="pageInfo postCard">
      <div class="postCardCnt">
        <div class="postCardL">
          <div :class="{thePostcard: true, viewBack: viewBack, page2: page === 1}">
            <div class="postcardImgInfo" v-on:click="viewBack = !viewBack">
              Lihat Tampilan
              <span v-if="!viewBack">Belakang</span>
              <span v-if="viewBack">Depan</span>
            </div>
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <div class="toLabel">Dear Pak Jokowi,</div>
                <div class="userFullName">{{userFullName}}</div>
                <div class="messageContent">{{form.message.model}}</div>
              </div>
              <div class="flip-card-back" :class="bgSelected"></div>
            </div>
          </div>
        </div>
        <div class="postCardR">
          <div class="theInfo info1" v-if="page === 0">
            <h4>Isi informasi kartu pos</h4>
            <div class="fieldGroup field2">
              <div :class="{fieldCnt: true, hasError: form.firstName.error}">
                <label>Nama depan</label>
                <input type="text" class="field" placeholder="Nama depan kamu..."
                  v-model="form.firstName.model" v-on:input="nameChanged"
                  ref="firstName">
                <div class="filedError" v-if="form.firstName.error">
                  {{form.firstName.error}}</div>
              </div>
              <div class="fieldCnt">
                <label>Nama belakang</label>
                <input type="text" class="field" placeholder="Isi nama belakang..."
                  v-model="form.lastName.model" v-on:input="nameChanged">
              </div>
            </div>
            <div class="fieldGroup email">
              <div :class="{fieldCnt: true, hasError: form.email.error}">
                <label>Email</label>
                <input type="text" class="field" placeholder="Alamat email kamu..."
                  v-model="form.email.model" v-on:input="fieldChanged('email')"
                  ref="email">
                <div class="fieldInfo" v-if="!form.email.error">
                  Gambar kartu pos akan dikirimkan ke email kamu.
                </div>
                <div class="filedError" v-if="form.email.error">
                  {{form.email.error}}</div>
              </div>
            </div>
            <div class="fieldGroup check">
              <div :class="{fieldCnt: true}">
                <label>
                  <input type="checkbox" v-model="form.check.model">
                  Saya bersedia mendapatkan update dan komunikasi lebih lanjut terkait kampanye ini
                </label>
              </div>
            </div>
            <div class="fieldGroup">
              <div :class="{fieldCnt: true, hasError: form.message.error}">
                <label>Isi pesan</label>
                <textarea class="field" rows="4" v-model="form.message.model"
                  v-on:input="fieldChanged('message')" ref="message"
                  placeholder="Isi pesan yang ingin kamu sampaikan ke Pak Jokowi...."></textarea>
                <div class="filedError" v-if="form.message.error">
                  {{form.message.error}}</div>
              </div>
            </div>
          </div>
          <div class="theInfo info2" v-if="page === 1">
            <h4>Pilih Gambar Belakang Kartu Pos</h4>
            <div class="imageSelector">
              <div :class="{imageItem: true, img1: true, selected: bgSelected === 'img1'}"
                v-on:click="bgSelected = 'img1'"></div>
              <div :class="{imageItem: true, img2: true, selected: bgSelected === 'img2'}"
                v-on:click="bgSelected = 'img2'"></div>
              <div :class="{imageItem: true, img3: true, selected: bgSelected === 'img3'}"
                v-on:click="bgSelected = 'img3'"></div>
              <div :class="{imageItem: true, img4: true, selected: bgSelected === 'img4'}"
                v-on:click="bgSelected = 'img4'"></div>
              <div :class="{imageItem: true, img5: true, selected: bgSelected === 'img5'}"
                v-on:click="bgSelected = 'img5'"></div>
              <div :class="{imageItem: true, img6: true, selected: bgSelected === 'img6'}"
                v-on:click="bgSelected = 'img6'"></div>
              <div :class="{imageItem: true, img7: true, selected: bgSelected === 'img7'}"
                v-on:click="bgSelected = 'img7'"></div>
              <div :class="{imageItem: true, img8: true, selected: bgSelected === 'img8'}"
                v-on:click="bgSelected = 'img8'"></div>
              <div :class="{imageItem: true, img9: true, selected: bgSelected === 'img9'}"
                v-on:click="bgSelected = 'img9'"></div>
            </div>
          </div>
          <div class="postCardRFooter">
            <button class="btnPrev" v-if="page === 1"
              v-on:click="page = 0; viewBack = false">Sebelumnya</button>
            <button class="btnOk" v-if="page === 0"
              v-on:click="goNext">Berikutnya</button>
            <button class="btnOk" v-if="page === 1"
              v-on:click="doSave">Buat Kartu Pos</button>
          </div>
        </div>
      </div>
    </div>
    <PostcardGenerator ref="postcardGenerator"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import PostcardGenerator from '@/components/PostcardGenerator.vue';

export default {
  name: 'postcard',
  components: { Header, PostcardGenerator },
  data() {
    return {
      loading: false,
      page: 0,
      userFullName: '',
      bgSelected: 'img1',
      viewBack: false,
      form: {
        firstName: {
          model: '',
          error: null,
        },
        lastName: {
          model: '',
          error: null,
        },
        email: {
          model: '',
          error: null,
        },
        check: {
          model: true,
        },
        message: {
          model: '',
          error: null,
        },
      },
    };
  },
  methods: {
    nameChanged() {
      this.form.firstName.error = null;
      const fullName = `${this.form.firstName.model} ${this.form.lastName.model}`.trim();
      this.userFullName = (fullName && fullName !== '') ? `Dari: ${fullName}` : '';
    },
    goNext() {
      if (!this.form.firstName.model || this.form.firstName.model === '') {
        this.form.firstName.error = 'Mohon isi nama depan kamu.';
        this.$refs.firstName.focus();
        return;
      }
      if (!this.form.email.model || this.form.email.model === '') {
        this.form.email.error = 'Mohon isi alamat email kamu.';
        this.$refs.email.focus();
        return;
      }
      if (!this.form.message.model || this.form.message.model === '') {
        this.form.message.error = 'Mohon isi pesan untuk Pak Jokowi.';
        this.$refs.message.focus();
        return;
      }
      this.page = 1;
      this.viewBack = true;
    },
    doSave() {
      document.body.classList.add('hideoverflow');
      this.$refs.postcardGenerator.open({
        firstName: this.form.firstName.model,
        lastName: this.form.lastName.model,
        email: this.form.email.model,
        check: this.form.check.model,
        message: this.form.message.model,
        backImg: this.bgSelected,
      });
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
  },
  computed: {},
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Kartu Pos - Mengabarkan Kita Tenggelam - Bumi Butuh Aksi';
  },
};
</script>

<style scoped lang="scss">
.pageInfo.postCard{
  height: 100vh;
  position: relative;
  @media (max-width: 959px) {
    height: auto;
    padding-top: 80px;
  }
  @media (max-width: 768px) {
    padding-top: 64px;
  }
  .postCardCnt{
    position: absolute;
    top: 80px; left: 0; right: 0; bottom: 0;
    @media (max-width: 959px) {
      position: static;
    }
    .postCardL{
      position: absolute;
      left: 0; right: 600px; top: 0; bottom: 0;
      background-color: #f5f5f5;
      @media (max-width: 1210px) {
        right: auto;
        width: 600px;
      }
      @media (max-width: 959px) {
        position: static;
        width: auto;
        padding: 40px 0 20px;
      }
      @media (max-width: 680px) {
        padding: 20px 16px 6px;
      }
      .thePostcard{
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        background-color: transparent;
        width: 540px;
        height: 380px;
        perspective: 1000px;
        margin-top: -40px;
        @media (max-width: 959px) {
          position: static;
          transform: none;
          margin: 0 auto 80px;
        }
        @media (max-width: 680px) {
          width: auto;
          height: 64vw;
        }
        .postcardImgInfo{
          position: absolute;
          left: 50%; bottom: -60px;
          transform: translateX(-50%);
          padding: 8px 14px;
          border: none;
          border-radius: 3px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all .3s ease;
          display: inline-block;
          padding-left: 42px;
          outline: 0;
          background-color: #fff;
          color: #444;
          box-shadow: 2px 2px 4px rgba(0,0,0,.1);
          &:hover{
            background-color: #d5d5d5;
            box-shadow: 2px 2px 6px rgba(0,0,0,.2);
          }
          &:before{
            width: 18px;
            position: absolute;
            left: 14px; top: 0; bottom: 0;
            content: "";
            background-position: center;
            background-size: 18px auto;
            background-repeat: no-repeat;
            opacity: .7;
            background-image: url(../assets/switch-black.png);
          }
          @media (max-width: 680px) {
            white-space: nowrap;
          }
        }
        .flip-card-inner {
          position: relative;
          width: 100%;
          height: 100%;
          text-align: center;
          transition: transform 0.6s;
          transform-style: preserve-3d;
          box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        }
        &.viewBack{
          .flip-card-inner {
            transform: rotateY(180deg);
          }
        }
        .flip-card-front, .flip-card-back {
          position: absolute;
          width: 100%;
          height: 100%;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          font-family: 'Roboto Mono', monospace;
        }
        .flip-card-front {
          background-color: #999;
          color: black;
          background-position: center;
          background-size: cover;
          background-image: url(../assets/postcard/postcard-front.png);
          font-size: 12px;
          @media (max-width: 680px) {
            font-size: 7px;
          }
          .toLabel{
            position: absolute;
            left: 34px; top: 34px;
            @media (max-width: 680px) {
              top: 20px; left: 20px;
            }
          }
          .userFullName{
            position: absolute;
            bottom: 34px; left: 34px;
            @media (max-width: 680px) {
              bottom: 20px; left: 20px;
            }
          }
          .messageContent{
            position: absolute;
            left: 34px; top: 60px;
            width: 216px;
            text-align: left;
            white-space: pre-wrap;
            line-height: 1.2;
            @media (max-width: 680px) {
              top: 36px; left: 20px;
            }
          }
        }
        .flip-card-back {
          background-color: #2980b9;
          color: white;
          transform: rotateY(180deg);
          background-position: center;
          background-size: cover;
          background-color: #ddd;
          &.img1{
            background-image: url(../assets/postcard/postcard-back-1.png);
          }
          &.img2{
            background-image: url(../assets/postcard/postcard-back-2.png);
          }
          &.img3{
            background-image: url(../assets/postcard/postcard-back-3.png);
          }
          &.img4{
            background-image: url(../assets/postcard/doly_postcard1.jpg);
          }
          &.img5{
            background-image: url(../assets/postcard/doly_postcard2.jpg);
          }
          &.img6{
            background-image: url(../assets/postcard/doly_postcard3.jpg);
          }
          &.img7{
            background-image: url(../assets/postcard/irene_postcard1.jpg);
          }
          &.img8{
            background-image: url(../assets/postcard/irene_postcard2.jpg);
          }
          &.img9{
            background-image: url(../assets/postcard/irene_postcard3.jpg);
          }
        }
      }
    }
    .postCardR{
      position: absolute;
      top: 0; right: 0; bottom: 0;
      width: 600px;
      @media (max-width: 1210px) {
        width: auto;
        left: 600px;
      }
      @media (max-width: 959px) {
        position: static;
      }
      @media (max-height: 640px) {
        overflow-y: auto;
      }
      .postCardRFooter{
        position: absolute;
        left: 0; right: 0; bottom: 0;
        border-top: #eee 1px solid;
        text-align: right;
        padding: 10px 30px;
        @media (max-width: 959px) {
          position: static;
        }
        @media (max-width: 680px) {
          padding: 10px 16px;
        }
        @media (max-height: 640px) {
          position: static;
        }
        button{
          padding: 8px 20px;
          border: none;
          border-radius: 3px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all .3s ease;
          &.btnPrev{
            background-color: #eee;
            color: #444;
            float: left;
            &:hover{
              background-color: #d5d5d5;
              box-shadow: 2px 2px 6px rgba(0,0,0,.2);
            }
          }
          &.btnOk{
            background-color: #0b845c;
            color: #fff;
            margin-left: 10px;
            &:hover{
              background-color: #006d49;
              box-shadow: 2px 2px 6px rgba(0,0,0,.2);
            }
          }
        }
      }
      .theInfo{
        padding: 30px;
        padding-bottom: 100px;
        position: absolute;
        left: 0; right: 0; top: 50%;
        transform: translateY(-50%);
        @media (max-width: 959px) {
          position: static;
          transform: none;
          padding-bottom: 20px;
        }
        @media (max-width: 680px) {
          padding: 20px 16px;
        }
        @media (max-height: 640px) {
          position: static;
          transform: none;
          padding-bottom: 0;
        }
      }
      h4{
        font-size: 26px;
        margin: 0 0 10px;
      }
      .imageSelector{
        display: flex;
        flex-wrap: wrap;
        margin: 0 -6px;
        .imageItem{
          width: calc(25% - 12px);
          height: 100px;
          background-color: #eee;
          box-sizing: border-box;
          margin: 0 6px 12px;
          border-radius: 3px;
          border: #fff 2px solid;
          background-size: cover;
          background-position: center;
          @media (max-width: 1200px) {
            width: calc(33.33333% - 12px);
          }
          &:hover{
            border-color: #999;
          }
          &.selected{
            border-color: #0b845c;
          }
          &.img1{
            background-image: url(../assets/postcard/postcard-back-1.png);
          }
          &.img2{
            background-image: url(../assets/postcard/postcard-back-2.png);
          }
          &.img3{
            background-image: url(../assets/postcard/postcard-back-3.png);
          }
          &.img4{
            background-image: url(../assets/postcard/doly_postcard1.jpg);
          }
          &.img5{
            background-image: url(../assets/postcard/doly_postcard2.jpg);
          }
          &.img6{
            background-image: url(../assets/postcard/doly_postcard3.jpg);
          }
          &.img7{
            background-image: url(../assets/postcard/irene_postcard1.jpg);
          }
          &.img8{
            background-image: url(../assets/postcard/irene_postcard2.jpg);
          }
          &.img9{
            background-image: url(../assets/postcard/irene_postcard3.jpg);
          }
        }
      }
      .fieldGroup{
        margin-bottom: 20px;
        &.email{
          margin-bottom: 8px;
        }
        &.field2{
          display: flex;
          margin: 0 -6px 20px;
          @media (max-width: 1049px) {
            display: block;
            margin: 0;
          }
          .fieldCnt{
            width: calc(50% - 12px);
            margin: 0 6px;
            @media (max-width: 1049px) {
              width: auto;
              margin: 0 0 20px;
            }
          }
        }
        .fieldCnt{
          label{
            display: block;
            text-transform: uppercase;
            font-size: 12px;
            font-weight: 800;
            color: #767676;
            padding-left: 4px;
            font-family: 'Open Sans', sans-serif;
            margin-bottom: 4px;
          }
          .field{
            font-family: 'Open Sans', sans-serif;
            border: #ccc 1px solid;
            background-color: #fff;
            padding: 10px;
            border-radius: 5px;
            box-shadow: none;
            width: 100%;
            box-sizing: border-box;
            font-size: 16px;
            outline: 0;
            &:hover{
              border-color: #fff !important;
              box-shadow: 0 0 0 2px #999;
            }
            &:focus{
              border-color: #fff !important;
              box-shadow: 0 0 0 2px #0b845c;
            }
          }
          &.hasError{
            .field{
              &:hover{
                border-color: #fff !important;
                box-shadow: 0 0 0 2px red;
              }
              &:focus{
                border-color: #fff !important;
                box-shadow: 0 0 0 2px red;
              }
              border-color: red;
            }
          }
          .filedError{
            color: red;
            font-size: 12px;
            padding: 4px 0 0 7px;
          }
          .fieldInfo{
            color: #767676;
            font-size: 12px;
            padding: 4px 0 0 7px;
          }
        }
        &.check{
          .fieldCnt{
            label{
              font-weight: normal;
              color: #444;
              text-transform: none;
              font-size: 15px;
              cursor: pointer;
              padding-left: 28px;
              position: relative;
              input{
                position: absolute;
                left: 0; top: 2px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
